import formatProjectApi from 'utils/format-project-api.js';

/**
 * @name AddProjectController
 * @description Controller called by the add project component.
 * @param {Unknown} _ Lodash
 * @param {Unknown} $log Angular log service
 * @param {Unknown} StyleFactory The style service
 * @param {Unknown} filterFilter The filter service
 * @param {Unknown} Project The project service
 * @param {Unknown} FormatProject The format project service
 * @param {Unknown} $document The Angular $document service
 */
function AddProjectController(
  _,
  $log,
  StyleFactory,
  filterFilter,
  Project,
  FormatProject,
  $document
) {
  let vm = this;
  vm.$onInit = function() {
    vm.steps = [
      {
        id: 1,
        name: 'description',
        title: 'Describe your project',
        description: `Give your project a name and describe your concept with as
        much detail as possible.`
      },
      {
        id: 2,
        name: 'reference-photos',
        title: 'Add reference photos',
        description: `Good reference photos will help show your artist your
        vision and communicate the details you’re looking for in your project.
        Upload as many as you need.`
      },
      {
        id: 3,
        name: 'location',
        title: 'Add a location',
        description: `Select the area on your body where you’d like your new
        tattoo and send photos of the area to allow your artist to plan
        properly.`
      },
      {
        id: 4,
        name: 'body-placement',
        title: 'Add placement photos',
        description: `Show your artist the area on your body where you want your
        tattoo. If you want to cover-up an existing tattoo, be sure to send a
        clear photo of your existing tattoo.`
      },
      {
        id: 5,
        name: 'size',
        title: 'Select a size',
        description: `Select the ideal size for your project. Remember, smaller
        sizes require less detail and aren’t always quick to produce.`
      },
      {
        id: 6,
        name: 'style',
        title: 'Define your style',
        description: `Select a color profile and style for your art. Some
        artists are better at certain styles, so be sure the style you like
        matches well with the artist you want.`
      },
      {
        id: 7,
        name: 'confirmation',
        title: 'Confirm your project',
        description: `Give your project a quick look. You can always update it
        later, if needed.`
      }
    ];
    vm.newProject = {
      appointments: []
    };
    vm.referenceImages = [];
    vm.coverupImages = [];
    vm.selectedSize = '';
    vm.activeStep = _.find(vm.steps, {name: 'description'});
    vm.nextStep = nextStep;
    vm.previousStep = previousStep;
    vm.startOver = startOver;
    vm.getOptions = getOptions;
    vm.processSize = processSize;
    vm.selectStyle = selectStyle;
    vm.addProject = addProject;
    vm.top = 0;
    vm.duration = 500; // milliseconds
    getOptions();
  };

  /**
   * @name prepareConfirmation
   * @description Function to prepare a confirmation step for the project
   */
  function prepareConfirmation() {
    let apiFormattedProject = formatProjectApi(vm.newProject);
    vm.formattedNewProject = {
      project: FormatProject.format(apiFormattedProject)
    };
    $log.debug('Formatted project: ', vm.formattedNewProject);
  }

  /**
   * @name nextStep
   * @description Function to advance the add project step
   * @param {object} activeStep The current step of the workflow
   */
  function nextStep(activeStep) {
    vm.activeStep = _.find(vm.steps, {id: (activeStep.id + 1)});
    if (_.findLastIndex(vm.steps) === (vm.activeStep.id - 1)) {
      prepareConfirmation();
    }
    $document.scrollTop(vm.top, vm.duration);
  }

  /**
   * @name previousStep
   * @description Function to advance the add project step
   * @param {object} activeStep The current step of the workflow
   */
  function previousStep(activeStep) {
    vm.activeStep = _.find(vm.steps, {id: (vm.activeStep.id - 1)});
    $document.scrollTop(vm.top, vm.duration);
  }

  /**
   * @name startOver
   * @description Function to start the process over again
   */
  function startOver() {
    vm.activeStep = _.find(vm.steps, {id: 1});
  }

  /**
   * @name processSize
   * @description Select the Size
   * @param {object} size The select size
   */
  function processSize(size) {
    vm.newProject.size =
    _.find(vm.options.sizes, {id: size.id});
  }

  /**
   * @name getOptions
   * @description Get the Size/Placement/Area/Style Options
   */
  function getOptions() {
    Project.getOptions().then(function(options) {
      vm.options = options;
    });

    StyleFactory.getStyles().then(function(styles) {
      vm.styles = styles;
    });
  }

  /**
   * @name selectStyle
   * @description Function to set the style on newProject to the selected style
   * @param {object} style The selected style
   */
  function selectStyle(style) {
    vm.newProject.style = style;
  }

  /**
   * @name addProject
   * @description Function to push the finished project up to the parent
   * component
   * @param {object} project The project to push up
   */
  function addProject(project) {
    $log.debug('Completed project: ', project);
    vm.onComplete({project: project});
  }
}

angular
  .module('inkfinder')
  .controller('AddProjectController', AddProjectController);



// WEBPACK FOOTER //
// ./components/projects/project/add/add-project.controller.js